import { render, staticRenderFns } from "./FirmFilesDescriptionCell.vue?vue&type=template&id=8364a01e&scoped=true"
import script from "./FirmFilesDescriptionCell.vue?vue&type=script&lang=js"
export * from "./FirmFilesDescriptionCell.vue?vue&type=script&lang=js"
import style0 from "./FirmFilesDescriptionCell.vue?vue&type=style&index=0&id=8364a01e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8364a01e",
  null
  
)

export default component.exports